import { render } from "./Predictions.vue?vue&type=template&id=4f7c5696&scoped=true"
import script from "./Predictions.vue?vue&type=script&lang=js"
export * from "./Predictions.vue?vue&type=script&lang=js"

import "./Predictions.vue?vue&type=style&index=0&id=4f7c5696&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f7c5696"]])

export default __exports__